import { helper } from '@ember/component/helper';

export const stopPropagation = ([handler]) => (e) => {
  e.stopPropagation();
  handler?.(e);
};

export default helper(stopPropagation);
